import { render } from "./FormMenuItem.vue?vue&type=template&id=b7f51cf2&ts=true"
import script from "./FormMenuItem.vue?vue&type=script&lang=ts"
export * from "./FormMenuItem.vue?vue&type=script&lang=ts"

import "./FormMenuItem.vue?vue&type=style&index=0&id=b7f51cf2&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__